<template>
  <div class="navbar clearfix">
    <div class="platLog">
      <a href="/">
        <!--        腾讯里约-->
        <!--        <span>· 开放平台</span>-->
        <img :src="logo || defaultLogo" />
        <span v-if="nameDisplay" class="managePlat">{{ name }}</span>
      </a>
    </div>
    <div class="userInfo">
      <span class="username">开发者中心</span>
    </div>

    <div class="notice" id="global-notice" style="opacity: 0;">
      <div>
        <img src="../assets/images/check.svg" />
        <span id="notice"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: '',
      title: '',
      nameDisplay: '',
      defaultLogo: require('../assets/images/icon_logo.png'),
    };
  },
  created() {
    this.fetchLogo();
  },
  methods: {
    fetchLogo() {
      this.$api
        .fetchLogo()
        .then((res) => {
          if (res.data.errcode === '0') {
            this.logo = res.data.data.logo;
            this.name = res.data.data.name;
            this.nameDisplay = res.data.data.nameDisplay;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.notice {
  transition: opacity 0.3s;
}
</style>
